/**
 * Returns the string with a trailing slash removed, for safe URL/path concatenation.
 * Use when building URLs to avoid double slashes (e.g. base + '/api/...').
 */
function stripTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

export default stripTrailingSlash;
